import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import PlayView from "../views/PlayView.vue";
import {
  isBeforeOpening,
  isAfterGameEnd,
  isFinishAvailable,
  isAfterRegularization,
  BYPASS_DATE_GUARDS,
} from "../config/campaign";

Vue.use(VueRouter);

function guardRoot(to, from, next) {
  if (isBeforeOpening()) {
    next({ name: "wait", replace: true });
  } else if (!BYPASS_DATE_GUARDS && isAfterGameEnd()) {
    next({ name: isFinishAvailable() ? "finish" : "home", replace: true });
  } else {
    next();
  }
}

function guardGameOpen(to, from, next) {
  if (BYPASS_DATE_GUARDS) {
    next();
    return;
  }

  if (isBeforeOpening()) {
    next({ name: "wait", replace: true });
  } else if (isAfterGameEnd()) {
    next({ name: isFinishAvailable() ? "finish" : "home", replace: true });
  } else {
    next();
  }
}

function guardDone(to, from, next) {
  if (BYPASS_DATE_GUARDS) {
    if (!sessionStorage.getItem("lot")) {
      next({ name: "form", replace: true });
      return;
    }
    next();
    return;
  }

  if (isBeforeOpening()) {
    next({ name: "wait", replace: true });
  } else if (isAfterGameEnd()) {
    next({ name: isFinishAvailable() ? "finish" : "home", replace: true });
  } else if (!sessionStorage.getItem("lot")) {
    next({ name: "form", replace: true });
  } else {
    next();
  }
}

function guardStatusAccess(to, from, next) {
  if (BYPASS_DATE_GUARDS) {
    next();
    return;
  }

  if (isBeforeOpening()) {
    next({ name: "wait", replace: true });
  } else if (isAfterRegularization()) {
    next({ name: "finish", replace: true });
  } else {
    next();
  }
}

const routes = [
  {
    path: "/",
    name: "root",
    component: HomeView,
    beforeEnter: guardRoot,
  },
  {
    path: "/home",
    name: "home",
    component: HomeView,
    beforeEnter: guardGameOpen,
  },
  {
    path: "/play",
    name: "play",
    component: PlayView,
    beforeEnter: guardGameOpen,
  },
  {
    path: "/status/:_id/:_secu",
    name: "status",
    component: () => import("../views/StatusView.vue"),
    beforeEnter: guardStatusAccess,
  },
  {
    path: "/finish",
    name: "finish",
    component: () => import("../views/FinishView.vue"),
  },
  {
    path: "/close",
    name: "close",
    component: () => import("../views/CloseView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/form",
    name: "form",
    component: () => import("../views/FormView.vue"),
    beforeEnter: guardGameOpen,
  },
  {
    path: "/form2",
    name: "form2",
    component: () => import("../views/Form2View.vue"),
    beforeEnter: guardGameOpen,
  },
  {
    path: "/wait",
    name: "wait",
    component: () => import("../views/WaitView.vue"),
  },
  {
    path: "/done",
    name: "done",
    component: () => import("../views/DoneView.vue"),
    beforeEnter: guardDone,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
